// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"24":"reset","681":"users","685":"register","768":"page"}[chunkId] + "." + {"24":"a4c38072","681":"8a205152","685":"8f4fae6f","768":"6cfe2bb7"}[chunkId] + ".js";
};